import c from "../common";

export default {
  text1: "Specific Shop Page",
  text2: "Specific Ad Page",
  text3: "My Coin",
  text4: "Promotion Code",
  text5: "Title & Content",
  text6: "Photo",
  text7: "Last push time",
  text8: "Target",
  text9: "All Consumer",
  text10: "Consumer",
  text11: "Last edit person",
  text12: "Use this template to send push notifications?",
  text13: "push",
  text14: "Push Time",
  text15: "Batch",
  text16: "Title",
  text17: "Detail",
  text18: "Promotion code is not ongoing",
  text19: "No phone to receive test notifications",
  text20: "Push Success",
  text21: "Manually entered phone format is incorrect",
  text22: "Error Occur",
  text23: "Create Success",
  text24: "Update Success",
  text25: "Deleted",
  text26: "Received / Total",
  text27: "Receive Method :",
  text28: "Receive notifications while using the app",
  text29: "Tap to open notifications in the background",
  text30: "Sender:",
  text31: "Content (required)",
  text32: "download",
  text33: "Choose Shop",
  text34: "Search Shop Name",
  text35: "Choose Ad",
  text36: "Search Ad Name",
  text37: "Choose Promotion Code",
  text38: "Search Promotion Code",
  text39: "Test on device",
  text40: "Enter the phone number to receive the test notification:",
  text41: "The test phone needs to allow the Push Notification function of Pearl App",
  text42: "Please enter a length of 10 digits",
  text43: "Already exists, please select from below",
  text44: "Add",
  text45: "recent phones:",
  text46: "select all",
  text47: "none",
  text48: "Notification",
  text49: "next",
  text50: "upload",
  text51: "Optional (only allow for Android)",
  text52: "Invalid image URL",
  text53: "send test message",
  text54: "Device Preview",
  text55: "Target",
  text56: "Format: xlsx file must have a column named tel, phone number example: 1234567890, repeated phone only count as one",
  text57: "Manual input",
  text58: "Use , to separate each phone, example: 1234567890",
  text59: "Partial Consumer",
  text60: "Upload xlsx",
  text61: "No valid phone number, please check xlsx format",
  text62: "selected phone:",
  text63: "Deep Link (Optional)",
  text64: "enable",
  text65: "No promotion code is ongoing",
  text66: "invalid format",
  text67: "Push Notification",
  text68: "Create Template",
  text69: "template",
  text70: "send log",
  text71: "Back",
  text72: "Create",
  text73: "Save Template",
  text74: "Are you sure you want to delete this template? This action cannot be undone",
  text75: "Delete",
  text76: "(download sample xlsx)",
};
